import axiosInstance from "./AxiosConfig";

class PlanMasterApi {

  // ---------------- CREATE ----------------
  async CreatePlan(data) {
    try {
      const response = await axiosInstance.post(
        "/planMaster/create",
        data
      );
      return response.data;
    } catch (error) {
      console.error("CreatePlan Error:", error);
      return null;
    }
  }

  // ---------------- GET ALL ----------------
  async GetAllPlans(includeDeleted = false) {
    try {
      const response = await axiosInstance.get(
        `/planMaster/get?includeDeleted=${includeDeleted}`
      );
      return response.data;
    } catch (error) {
      console.error("GetAllPlans Error:", error);
      return null;
    }
  }

  // ---------------- GET BY ID ----------------
  async GetPlanById(id) {
    try {
      const response = await axiosInstance.get(
        `/planMaster/get/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("GetPlanById Error:", error);
      return null;
    }
  }

  // ---------------- UPDATE ----------------
  async UpdatePlan(id, data) {
    try {
      const response = await axiosInstance.put(
        `/planMaster/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("UpdatePlan Error:", error);
      return null;
    }
  }

  // ---------------- DELETE (soft) ----------------
  async DeletePlan(id, data = {}) {
    try {
      const response = await axiosInstance.delete(
        `/planMaster/delete/${id}`,
        { data }
      );
      return response.data;
    } catch (error) {
      console.error("DeletePlan Error:", error);
      return null;
    }
  }
}

export default new PlanMasterApi();